interface IIcon {
  width?: string;
  height?: string;
}

const FailedIcon = ({ height = '14', width = '14' }: IIcon) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 0C9.81313 0 12.5 2.68687 12.5 6C12.5 9.31313 9.81313 12 6.5 12C3.18687 12 0.5 9.31313 0.5 6C0.5 2.68687 3.18687 0 6.5 0ZM5.8572 6.5163V3.42818C5.8572 3.07415 6.14598 2.78538 6.5 2.78538C6.85403 2.78538 7.1428 3.07684 7.1428 3.42818V6.5163C7.1428 6.86765 6.85402 7.15911 6.5 7.15911C6.14597 7.15911 5.8572 6.87033 5.8572 6.5163ZM6.49722 7.84854C6.89953 7.84854 7.22582 8.17482 7.22582 8.57708C7.22582 8.9794 6.89953 9.30568 6.49722 9.30568C6.09496 9.30568 5.76867 8.9794 5.76867 8.57708C5.76867 8.17482 6.09496 7.84854 6.49722 7.84854Z"
      fill="#FF0000"
    />
  </svg>
);
export default FailedIcon;
